import { Controller } from 'stimulus';
import toArray from '../helpers/toArray';
import wrapElement from '../helpers/wrapElement';

const WRAP_CLASS = 'table-responsive';

class TableWrapController extends Controller {
  connect() {
    this.check();
  }

  check() {
    const elements = TableWrapController.embeddableElements(this.element);

    elements.forEach((element) => {
      if (TableWrapController.isWrapped(element) || !TableWrapController.isWrappable(element)) {
        return;
      }

      TableWrapController.wrap(element);
    });
  }

  static wrap(element) {
    const wrapper = document.createElement('div');
    wrapper.className = WRAP_CLASS;

    wrapElement(element, wrapper);
  }

  static embeddableElements(containerElement) {
    return toArray(containerElement.querySelectorAll('table'));
  }

  static isWrappable(element) {
    if (element.className.indexOf('no-wrap') >= 0) {
      return false;
    }

    if (element.tagName === 'TABLE') {
      return true;
    }

    return TableWrapController.isWrappableSource(element);
  }

  static isWrapped(element) {
    return element.parentNode.className.indexOf(WRAP_CLASS) >= 0;
  }
}

TableWrapController.targets = [
  //
];

export default TableWrapController;
